export default __webpack_public_path__ + "static/media/IMG_4561-min.cb21bf96.JPG";